import { SxProps, Theme } from '@mui/material'
import { menuItemClasses } from '@mui/material/MenuItem'

// Height of the filter-bar buttons. Their dropdown Poppers overlap the button, so they are offset by it minus the
// 1px border and rounded by half of it.
export const FILTER_BTN_HEIGHT = 40
export const FILTER_MENU_OFFSET = FILTER_BTN_HEIGHT - 1
export const FILTER_MENU_RADIUS = `${FILTER_BTN_HEIGHT / 2}px`

// Dropdown Paper of the filter-bar buttons (Sort, Image Size, Items Per Page, ...). The top padding leaves room for
// the button the Popper overlaps.
export const filterMenuPaperSx: SxProps<Theme> = {
  paddingTop: `${FILTER_MENU_OFFSET}px`,
  [`& .${menuItemClasses.root}`]: {
    fontSize: '14px',
    minHeight: '40px',
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: '#f0f9f7',
    },
    [`&.${menuItemClasses.selected}`]: {
      color: '#005058',
      fontWeight: 500,
      backgroundColor: 'transparent',
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: '#dcece8',
      },
    },
  },
}
